import {
  createApi,
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../constants";
import { RootState } from "./index";
// import { useAuth } from "@clerk/clerk-react"; // Import Clerk's getAuth function

const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const state = getState() as RootState;
      const mover = state.movers.selectedMover;
      // const moverId = state.movers.selectedMoverId || "";

      const getToken = state.session.getTokenFn;
      const clerkToken = await getToken();
      const mobileToken = state.session.mobileToken;

      if (clerkToken || mobileToken) {
        headers.set(
          mobileToken ? "X-Access-Token" : "Authorization",
          `Bearer ${clerkToken || mobileToken}`
        );
        headers.set("MOVER-ID", mover?.id.toString() || "");
        headers.set("Content-Type", "application/json");
        headers.set("Accept", "application/json");
      }
      return headers;
    },
  });

  return baseQuery(args, api, extraOptions);
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getStatus: builder.query({
      query: () => `status`,
    }),
  }),
});
